import { useState } from "react"
import styled from "styled-components"

import { useAppSelector } from "store/hooks"
import SubscriptionPrivilege from "types/enums/SubscriptionPrivilege"

import hasSubscriptionAccess from "utils/hasSubscriptionAccess"
import { SubscriptionUpgradeModal } from "modals/SubscriptionUpgradeModal/SubscriptionUpgradeModal"
import { ButtonNew } from "components/form/ButtonNew"

const RestrictedContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 16px;
  padding: 20px 0;
`

const RestrictedText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: var(--text-muted);
  text-align: center;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`

interface RestrictedAccessWidgetProps {
  privilege: SubscriptionPrivilege
  children: React.ReactNode
}

export const RestrictedAccessWidget = ({ privilege, children }: RestrictedAccessWidgetProps) => {
  const userProfile = useAppSelector(state => state.user.userProfile)
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)
  const hasAccess = userProfile ? hasSubscriptionAccess(userProfile, privilege) : false

  if (hasAccess) {
    return <>{children}</>
  }

  return (
    <>
      <RestrictedContent>
        <RestrictedText>Not available in the current Subscription plan</RestrictedText>
        <ButtonWrapper>
          <ButtonNew onClick={() => setShowUpgradeModal(true)} size="auto" color="blue">
            Upgrade
          </ButtonNew>
        </ButtonWrapper>
      </RestrictedContent>
      {showUpgradeModal && (
        <SubscriptionUpgradeModal
          page={privilege}
          hideUnavailableModal={true}
          onCancel={() => setShowUpgradeModal(false)}
        />
      )}
    </>
  )
}
